import type { ExtensionManifest } from '../types';
import { EXTENSION_MANIFESTS } from '../../../supabase/functions/_shared/extension-manifests';

// The data lives in supabase/functions/_shared/extension-manifests.ts so
// partnr-chat can read the same manifest.
export const creativeScoutManifest = EXTENSION_MANIFESTS.find(
  (m) => m.id === 'creative-scout',
) as ExtensionManifest;
